import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import RiskDisclaimerCondensed from './RiskDisclaimerCondensed';
import {
  TradeStationHomeSoftPromoFooterNote,
  TradeStationPromoFootnoteLine,
  useTradeStationPublicPromoFootnoteVisible,
} from './TradeStationReferralPromoBar';

function TradeStationPromoOfferSiteFooterNote() {
  const { colors } = useTheme();
  const show = useTradeStationPublicPromoFootnoteVisible();
  if (!show) return null;
  return (
    <div className="footer-disclaimer footer-disclaimer--lead footer-ts-promo-offer-note">
      <TradeStationPromoFootnoteLine colors={colors} align="left" />
    </div>
  );
}

const CONTACT_LINKS = [
  { to: '/contact', label: 'Contact us' },
];

const LEGAL_LINKS = [
  { to: '/legal#terms', label: 'Terms of Service' },
  { to: '/legal#privacy', label: 'Privacy Policy' },
  { to: '/legal#risk', label: 'Risk Disclosure' },
];

const SiteFooter = ({
  containerClass = '',
  showRiskDisclaimer = false,
  showTradeStationDisclosure = false,
  /** When true, omit outbound nav links (e.g. isolated paid-acquisition landing funnel) */
  isolatedLanding = false,
  /**
   * `home-soft`: /home footer TradeStation note — left-aligned *, no promo code in copy (in-app delivery).
   * `default`: left-aligned * line with code + funding when {@link useTradeStationPublicPromoFootnoteVisible}.
   */
  tradeStationPromoFooterMode = 'default',
}) => {
  const promoFooterNote =
    tradeStationPromoFooterMode === 'home-soft' ? (
      <TradeStationHomeSoftPromoFooterNote />
    ) : (
      <TradeStationPromoOfferSiteFooterNote />
    );

  return (
    <footer className="footer site-footer">
      <div className={containerClass || undefined}>
        {promoFooterNote}
        <div className="footer-content">
          <div className="footer-brand">
            <p className="footer-brand-name">PrecisionTrader</p>
            <p className="footer-brand-tagline">Helping traders become better traders</p>
          </div>
          {!isolatedLanding && (
            <nav className="footer-nav" aria-label="Footer">
              <div className="footer-nav-col">
                <h2 className="footer-nav-heading">Contact</h2>
                <ul className="footer-nav-list">
                  {CONTACT_LINKS.map(({ to, label }) => (
                    <li key={to}>
                      <Link to={to}>{label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="footer-nav-col">
                <h2 className="footer-nav-heading">Legal</h2>
                <ul className="footer-nav-list">
                  {LEGAL_LINKS.map(({ to, label }) => (
                    <li key={to}>
                      <Link to={to}>{label}</Link>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
          )}
        </div>
        {showRiskDisclaimer && (
          <div className="footer-disclaimer" style={{ marginTop: '20px' }}>
            <RiskDisclaimerCondensed hideReadMoreLink={isolatedLanding} />
          </div>
        )}
        {showTradeStationDisclosure && (
          <div className="footer-disclaimer" style={{
            marginTop: '20px',
            padding: '20px',
            background: 'rgba(255, 255, 255, 0.02)',
            borderRadius: '8px',
            fontSize: '0.85em',
            lineHeight: '1.6',
            color: '#a0aec0',
            textAlign: 'left'
          }}>
            <p style={{ margin: 0 }}>
              <strong>Important Disclosure:</strong> PrecisionTrader is not affiliated or associated with, or a partner of,
              or an agent, representative, delegate, associated person or introducing broker for, any TradeStation company.
              The products and services offered by PrecisionTrader are not sponsored, endorsed, sold or promoted by any
              TradeStation company, and TradeStation makes no representation regarding any products or services offered
              by PrecisionTrader. Equities, equity options and commodity futures products and services are offered by
              TradeStation Securities, Inc. (Member NYSE, FINRA, CME and SIPC).
            </p>
          </div>
        )}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} PrecisionTrader. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
